import { render, staticRenderFns } from "./openstreetmap.vue?vue&type=template&id=20b21a1a&"
import script from "./openstreetmap.vue?vue&type=script&lang=js&"
export * from "./openstreetmap.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../../var/task/node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

/* hot reload */
if (module.hot) {
  var api = require("/var/task/node_modules/vue-hot-reload-api/dist/index.js")
  api.install(require('vue'))
  if (api.compatible) {
    module.hot.accept()
    if (!api.isRecorded('20b21a1a')) {
      api.createRecord('20b21a1a', component.options)
    } else {
      api.reload('20b21a1a', component.options)
    }
    module.hot.accept("./openstreetmap.vue?vue&type=template&id=20b21a1a&", function () {
      api.rerender('20b21a1a', {
        render: render,
        staticRenderFns: staticRenderFns
      })
    })
  }
}
component.options.__file = "tmp/tmp-8bYpL9Coyj52H/JS/comp/openstreetmap.vue"
export default component.exports